import styled from 'styled-components'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const PreparePlanStyles = {
  Root: styled.div`
    width: 100%;
    height: calc(100dvh - var(--header-height));

    &:before {
      position: absolute;
      z-index: -1;
      inset: 0;
      content: '';
      background-color: ${COLORS.GRAY_100};
    }
  `,

  StyledContainer: styled(Container)`
    padding: 24px 24px 32px;
    height: 100%;
    overflow-y: auto;
  `,

  Title: styled.h1`
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: ${COLORS.BLACK};
    text-align: center;
    margin-bottom: 24px;
  `,

  EnjoyTitle: styled.h2`
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    color: ${COLORS.BLACK};
    margin-bottom: 24px;
  `,

  ProgressContainer: styled.div`
    margin-bottom: 32px;
  `,

  Review: styled.div`
    padding: 12px;
    background: ${COLORS.WHITE};
    box-shadow: 0px 4px 10px 0px #3e0b8f1a;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,

  ReviewStars: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  `,

  ReviewText: styled.p`
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK_ALPHA_50};
    text-align: center;
  `,

  ReviewAuthor: styled.p`
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    color: ${COLORS.BLACK};
    text-align: center;
  `,
} as const
